<template>
  <div class="journals-component">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 text-center mt-5" v-for="(journal, index) in journals" :key="index">
            <div class="image-container">
              <!-- <div class="image" :style="backgroundImage(journal.image)"></div> -->
                <img :src="journal.image" :alt="`Image for ${journal.title}`" class="img-fluid" />
            </div>
            <br>
            <div class="journal-title">{{ journal.title }}</div>
            <div class="read-more mt-3">
              <a class="btn btn-sm btn-dutche-orange" :href="`/journals/${journal.slug}`">Read More</a>
            </div>
        </div>
        <div class="col-12 text-center mt-5">
            <ul class="list-inline">
              <li class="list-inline-item"><button @click.prevent="getJournals(previousPage)" class="btn btn-lg btn-dutche-violet" :disabled="previousPage == 'null'" v-show="previousPage !== 'null'"><i class="fa fa-arrow-left"></i> Previous</button></li>
              <li class="list-inline-item"><button @click.prevent="getJournals(nextPage)" class="btn btn-lg btn-dutche-violet"  :disabled="nextPage == 'null'" v-show="nextPage !== 'null'">Next <i class="fa fa-arrow-right"></i></button></li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Journals",
  data() {
    return {
      journals: undefined,
      nextPage: undefined,
      previousPage: undefined,
      prevPageValue: undefined,
      nextPageValue: undefined,
    };
  },
  mounted() {
    this.getJournals();
  },
  methods: {
    getJournals(path = '/journals') {
      axios.get(path).then(response => {
        this.journals = response.data.journals.data;
        this.nextPage = response.data.journals.next_page_url !== null ? response.data.journals.next_page_url.replace(/^.*\/\/[^/]+/, '') : "null";
        this.previousPage = response.data.journals.prev_page_url !== null ? response.data.journals.prev_page_url.replace(/^.*\/\/[^/]+/, '') : "null";
      });
    },
    backgroundImage(imageUrl) {
      return { backgroundImage: `url(${imageUrl})` };
    }
  }
};
</script>

<style lang="sass" scoped>
.journals-component

  .image-container
    height: 300px
    background-color: #bbb

    .img-fluid
      height: 100%

  .journal-title
    font-family: "Might Could"
    text-transform: uppercase
    font-weight: bold
    color: $dutche-primary-violet
    font-size: 1.5rem
    text-decoration: none

  a:hover, a:focus
    text-decoration: none
    color: $dutche-tertiary-violet

  .btn-dutche-violet
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-violet
    color: $white
    padding: 0.5rem 1rem
    width: 180px

  .btn-dutche-orange
    text-transform: uppercase
    border-radius: 0.5rem
    background-color: $dutche-primary-orange
    color: $white
</style>
